/* @generated */
import tokens from "../design-tokens/dist/dig/index.module.esm.js";
import { createJoinedObject } from "./utils.esm.js";
const { Type: _type } = tokens;
const typography = {
  ..._type,
  Size: {
    ...createJoinedObject(_type.Size.Text, "Text"),
    ...createJoinedObject(_type.Size.Title, "Title"),
    ...createJoinedObject(_type.Size.Action, "Action")
  },
  Lineheight: {
    ...createJoinedObject(_type.Lineheight.Text, "Text"),
    ...createJoinedObject(_type.Lineheight.Title, "Title"),
    ...createJoinedObject(_type.Lineheight.Label, "Label"),
    unset: "unset"
  }
};
export {
  typography
};
